function About() {
  return (
    <>
      <h1 className="text-6xl mb-4">Github Finder</h1>
      <p className="mb-4 text-2xl font-light">
        A React app to search GitHub profiles, profile details and repositories.
      </p>

      <p className="text-lg text-gray-400">
        <span>Github Finder Project By : </span>
        <a className="text-white" href="https://twitter.com/G_Uchechi">
          Godswill Uchechi
        </a> 
      </p>
    </>
  );
}

export default About;
